import { render, staticRenderFns } from "./materialCloud.vue?vue&type=template&id=05e9bf13&scoped=true&"
import script from "./materialCloud.vue?vue&type=script&lang=js&"
export * from "./materialCloud.vue?vue&type=script&lang=js&"
import style0 from "./materialCloud.vue?vue&type=style&index=0&id=05e9bf13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e9bf13",
  null
  
)

export default component.exports